import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions, ChartData } from 'chart.js';
import { Pie, Doughnut } from 'react-chartjs-2';
import { observer } from 'mobx-react';

import "./styles.scss"
import classnames from 'classnames';

ChartJS.register(ArcElement, Tooltip, Legend);

type Props = {
    labels: string[];
    values: number[];
    colors: string[];
    activeIndex: number | null;
    mode: 'outline' | 'scale';
    className?: string
};

export const PPDWidgetPieChartGraph = observer(({ labels, values, colors, activeIndex, mode, className }: Props) => {
    const innerPieData: ChartData<'pie'> = {
        labels,
        datasets: [{
            data: values,
            backgroundColor: colors,
            borderColor: "#FFFFFF",
            borderWidth: 1,
            radius: '100%' as any,
        } as any]
    };

    const outerPieData: ChartData<'pie'> = {
        labels,
        datasets: [{
            data: values,
            backgroundColor: colors.map((c, i) =>
                i === activeIndex ? c : 'transparent'
            ),
            borderWidth: 0,
            radius: '90%' as any,
        } as any]
    };

    const outerDoughnutData: ChartData<'doughnut'> = {
        labels,
        datasets: [{
            data: values,
            backgroundColor: colors.map((c, i) =>
                i === activeIndex ? c : 'transparent'
            ),
            borderWidth: 1,
            cutout: '91%' as any,
            radius: '92%' as any,
        } as any],
    };

    const pieOptions: ChartOptions<'pie'> = {
        plugins: { legend: { display: false }, tooltip: { enabled: false } },
        animation: { duration: 300 }
    };

    const outerDoughnutOptions: ChartOptions<'doughnut'> = {
        plugins: { legend: { display: false }, tooltip: { enabled: false } },
        animation: { animateRotate: true, animateScale: true },
    };

    return (
        <div className={classnames("ppd-widget-pie-chart-graph", className)}>
            {mode === "outline" && (
                <Doughnut data={outerDoughnutData} options={outerDoughnutOptions} />
            )}
            {mode === "scale" && (
                <Pie data={outerPieData} options={pieOptions} />
            )}
            <div className="ppd-widget-pie-chart-graph__inner">
                <Pie data={innerPieData} options={pieOptions} />
            </div>
        </div>
    );
});
